export default __webpack_public_path__ + "static/media/019-panda.9d0afe72.svg";